import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

@ccclass
export default class spendWeChatPrefab extends cc.Component {

    @property(cc.ScrollView)
    scrollView : cc.ScrollView = null;
    @property(cc.Node)
    contentNode : cc.Node = null;
    @property({type:cc.Prefab,displayName:"机器人聊天预制体"})
    robotChatItemPrefab : cc.Prefab = null;
    @property({type:cc.Prefab,displayName:"玩家聊天预制体"})
    playerChatItemPrefab : cc.Prefab = null;

    m_Round:number = 0;

    //关闭回调
    private mCloseCallBack:()=>void;

    bindData( closeCallBack ){
        this.mCloseCallBack = closeCallBack;

    }

    onLoad () {
        
    }

    /**
     * 选择
     * @param e
     * @param chooseDefine
    */
    onBtnChooseText( e , chooseDefine : string ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( chooseDefine == "1" ){
            // 选第一个
        }else{
            //选第二个
        }
    }

    updateChooseText(){
        //TODO 更新按钮数据
    }

}
